import { useTranslation } from 'react-i18next';
import { AlwaysIncluded } from '../shared/AlwaysIncluded';
import styles from '../shared/checkoutLayout.module.scss';
import { alwaysIncluded } from '../shared/data';
import {
  NoticeList,
  OrderLineItems,
  OrderTotals,
  PaymentMethods,
  PromoCodeField,
} from '../shared/primitives';
import { TrustBox } from '../shared/TrustBox';

export function OrderSummarySidebar() {
  const { t } = useTranslation();

  return (
    <aside className={styles.summary}>
      <NoticeList />
      <div className={styles.summaryBox}>
        <div className={styles.summaryTitle}>{t('Order summary')}</div>
        <OrderLineItems />
        <PromoCodeField />
        <OrderTotals />
        <PaymentMethods />
        <AlwaysIncluded items={alwaysIncluded} />
      </div>

      <TrustBox />
    </aside>
  );
}
